import { BadgeKind } from "constants/settings/interfaces";
import { SettingsSection } from "constants/settings/sections";

import { isExternalNavigationItem } from "./helpers";
import { INavigationItem, ISettingsSideNavigationItemWithBadge } from "./interfaces";

const getNavItemBadge = (
  navigationItem: INavigationItem,
  isLiveChatIntegrationEnabled: boolean,
  hasContactForms: boolean,
  ticketsForwardedToHelpDesk?: boolean,
  isOpenWidgetConnected?: boolean,
  isOpenWidgetTeamValid?: boolean
): BadgeKind | null => {
  if (isExternalNavigationItem(navigationItem)) {
    return BadgeKind.External;
  }
  switch (navigationItem.section) {
    case SettingsSection.EmailAddresses: {
      return ticketsForwardedToHelpDesk ? BadgeKind.On : BadgeKind.Off;
    }
    case SettingsSection.OpenWidget: {
      return isOpenWidgetConnected ? (isOpenWidgetTeamValid ? BadgeKind.On : BadgeKind.Error) : BadgeKind.Off;
    }
    case SettingsSection.LiveChat: {
      return isLiveChatIntegrationEnabled ? BadgeKind.On : BadgeKind.Off;
    }
    case SettingsSection.ContactForms: {
      return hasContactForms ? BadgeKind.On : BadgeKind.Off;
    }
    default:
      return null;
  }
};

export const getNavigationItemsWithBadges = (
  navigationItems: INavigationItem[],
  isLiveChatIntegrationEnabled: boolean,
  hasContactForms: boolean,
  ticketsForwardedToHelpDesk?: boolean,
  isOpenWidgetConnected?: boolean,
  isOpenWidgetTeamValid?: boolean
): ISettingsSideNavigationItemWithBadge[] =>
  navigationItems.map(navigationItem => {
    const badge = getNavItemBadge(
      navigationItem,
      isLiveChatIntegrationEnabled,
      hasContactForms,
      ticketsForwardedToHelpDesk,
      isOpenWidgetConnected,
      isOpenWidgetTeamValid
    );
    return badge ? { ...navigationItem, badgeKind: badge } : navigationItem;
  });
